import * as React from 'react';
import { SVGType } from '../types';

type ICopyIconProps = SVGType;

export const CopyIcon: React.FunctionComponent<ICopyIconProps> = ({ size = 26, stroke = '#693EB5', ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="none" viewBox="0 0 26 26" {...rest}>
      <path
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M23.53 6.333H7.809c-.814 0-1.473.66-1.473 1.473v15.721c0 .814.66 1.473 1.473 1.473h15.72c.814 0 1.474-.66 1.474-1.473V7.807c0-.814-.66-1.474-1.473-1.474z"
      ></path>
      <path
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M6.333 19.667H3.667A2.667 2.667 0 011 17V3.667A2.667 2.667 0 013.667 1H17a2.667 2.667 0 012.667 2.667v2.666"
      ></path>
    </svg>
  );
};

export default CopyIcon;
